import { createFileRoute } from "@tanstack/react-router";

import { ReturnsPage } from "../../../../features/purchasing/returns-page";

export const Route = createFileRoute("/_app/purchasing/returns/")({ component: ReturnsPage });
